<template>
    <template-editor></template-editor>
</template>

<script>
export default {
	mounted() {
		this.$store.dispatch("audit/template/resetState")
	}
}
</script>